export default __webpack_public_path__ + "static/media/bondly-usdt-closed-stub.49d4e302.svg";